export default "__VITE_ASSET__CStSPT0w__"